<mat-form-field class="field">
    <mat-label>Search</mat-label>
    <input matInput [formControl]="search" autocomplete="off" [placeholder]="placeHolder" #titleInput>
</mat-form-field>
<button type="submit" class="people-search-btn mr-2">
</button>